"use client";

import { ClerkLoaded, ClerkLoading } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import SplashScreen from "~/components/patterns/splash-screen";
import { isAgentReadyHost } from "~/lib/siteglue/agent-ready-host";
import { isClerkOptionalPath } from "~/lib/public-marketing-paths";

/**
 * Public marketing + auth pages render immediately so a slow Clerk load
 * does not leave the branded splash up. Sign-in/up pages handle their own Clerk loading.
 */
export function ClerkAuthGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? "/";

  const hostname = typeof window === "undefined" ? "" : window.location.hostname;
  if (isAgentReadyHost(hostname) || isClerkOptionalPath(pathname)) {
    return <>{children}</>;
  }

  return (
    <>
      <ClerkLoading>
        <SplashScreen />
      </ClerkLoading>
      <ClerkLoaded>{children}</ClerkLoaded>
    </>
  );
}
